module.exports = __webpack_public_path__ + "static/media/howItWorksInvesterIcon02.510f271e.svg";